import { render } from "./Withdrawal.vue?vue&type=template&id=72c545c8&scoped=true"
import script from "./Withdrawal.vue?vue&type=script&lang=js"
export * from "./Withdrawal.vue?vue&type=script&lang=js"

import "./Withdrawal.vue?vue&type=style&index=0&id=72c545c8&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c545c8"]])

export default __exports__